import { useState } from 'react';
import { Monitor, X } from 'lucide-react';
import { Button } from '@easyflow/ui-frontend/components/ui/button';
import { useIsMobile } from '@/hooks/use-media-query';

interface DesktopOnlyOverlayProps {
  title?: string;
  description?: string;
  /**
   * Optional callback invoked when the user taps "Torna indietro".
   * If not provided, falls back to history.back() when there is history,
   * otherwise navigates to "/" to avoid leaving the app.
   */
  onBack?: () => void;
  children: React.ReactNode;
}

export default function DesktopOnlyOverlay({
  title = 'Funzione ottimizzata per desktop',
  description = 'Questa schermata richiede uno schermo più grande per essere usata al meglio. Aprila da tablet o desktop, oppure forza la visualizzazione in modalità ridotta.',
  onBack,
  children,
}: DesktopOnlyOverlayProps) {
  const isMobile = useIsMobile();
  const [forced, setForced] = useState(false);

  if (!isMobile || forced) {
    return <>{children}</>;
  }

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }
    if (typeof window !== 'undefined') {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.assign('/');
      }
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-6 py-10 text-center">
      <div className="max-w-md w-full bg-card border rounded-2xl shadow-sm p-6">
        <div className="mx-auto w-14 h-14 rounded-2xl bg-primary/10 text-primary flex items-center justify-center mb-4">
          <Monitor className="w-7 h-7" />
        </div>
        <h2 className="text-lg font-semibold mb-2">{title}</h2>
        <p className="text-sm text-muted-foreground leading-relaxed mb-5">{description}</p>
        <div className="flex flex-col gap-2">
          <Button onClick={() => setForced(true)} className="w-full">
            Forza visualizzazione mobile
          </Button>
          <Button
            variant="outline"
            onClick={handleBack}
            className="w-full"
          >
            <X className="w-4 h-4 mr-1.5" /> Torna indietro
          </Button>
        </div>
      </div>
    </div>
  );
}
